import { useQuery, UseQueryResult } from 'react-query'
import { getAllCategorizedTreatments } from 'src/services/api/treatment'
import { CategorizedAndUniqueTreatments } from '@customTypes/CategorizedTreatment'
import { fiveMinutesInMiliseconds } from 'src/config/constants'
import { useIsAllClinicsVariant } from './useIsAllClinicsVariant'

export const useAllClinicsTreatments: () => UseQueryResult<CategorizedAndUniqueTreatments> = () => {
  const isAllClinicsVariant = useIsAllClinicsVariant()

  const result = useQuery(['allTreatments'], () => getAllCategorizedTreatments(), {
    retry: 3,
    enabled: isAllClinicsVariant,
    staleTime: fiveMinutesInMiliseconds,
  })

  return result
}
